import { useQuery } from '../use-query';
import { userVisitsService } from '../../../services';
import { toIsoDate } from '../../../utils';
import moment from 'moment';

export const useUserVisitsQuery = ({ lastVisitedAt, ...keys }: any = {}) => {
  if (lastVisitedAt) {
    const date = moment().subtract(lastVisitedAt, 'days').set({
      hour: 12,
      minute: 0,
      second: 0,
      millisecond: 0,
    });
    keys.lastVisitedAt = toIsoDate(date, true);
  }

  return useQuery(
    ['user-visits', JSON.stringify(keys)],
    () => {
      return userVisitsService
        .getAll({
          params: keys,
        })
        .then((res) => res.data);
    },
    { initialData: { data: [], totalCount: 0 }, keepPreviousData: true },
  );
};

export const useUserVisitQuery = (id = '') => {
  return useQuery(['gate-out', id], () => userVisitsService.get(id).then((res) => res.data), {
    initialData: { data: [], totalCount: 0 },
  });
};
